export function formatBalanceNumber(count: number, fractionDigits: number = 2): string {
    return count.toFixed(fractionDigits).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function numberWithCommas(count: number): string {
    return count.toFixed().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function renderTime(time: number, {h, m, s} : {h : string, m: string, s: string}) {
    const zeroPad = (num: number, places: number) => String(num).padStart(places, '0');
    const hours = Math.floor(time / 3600000);
    const minutes = Math.floor(time % 3600000 / 60000);
    const seconds = Math.floor(time % 60000 / 1000);
    return `${zeroPad(hours, 2)}${h} ${zeroPad(minutes, 2)}${m} ${zeroPad(seconds, 2)}${s}`
}

// XXXX...xxxx
export function formatAddress(address : string) : string {
    if (address.length < 10) return address;
    return address.substring(0, 4) + "..." + address.substring(address.length - 4);
}


export function formatDate(date: Date) {
    const zeroPad = (num : number, places : number) => String(num).padStart(places, '0')
    const pad2 = (num: number) => zeroPad(num, 2);
    return `${pad2(date.getDate())}.${pad2(date.getMonth() + 1)}.${pad2(date.getFullYear())}`
}
